define('optionalClassProgram/starter',['Vue', 'vue','vuex','moment','es6-promises','es6-promises-auto'],
    function (Vue, vue, vuex,moment) {
        var localStrings = app.localization.spaBooking;
        return function(item,classComponents){

            Vue.use(vuex);
            Vue.mixin({
                methods: {
                    classesGroupBy: function (item) {
                        switch (item.CascadeOption) {
                            case "I":
                                return item.SpaItemName + '|' + item.SpaItemId
                            case "TI":
                                return item.SpaItemName + " @ " + item.eventStartTime
                            case "T":
                                return  item.eventDate + " @ " + item.eventStartTime
                            default:
                                return item.CascadeOption
                        }
                    },
                    groupClasses: function (optionalComponent,customerID) {
                        var self = this
                        var classes = this.users[customerID]['classComponents'][optionalComponent]
                        return _.groupBy(classes, function (item) {
                            var eventStartTime = moment(item.StartTime, "YYYY-MM-DDHHmmss").format("hh:mm a"),
                                eventEndTime = moment(item.StartTime, "YYYY-MM-DDHHmmss").add(item.ServiceTime,'m').format("hh:mm a"),
                                eventDate = moment(item.StartTime, "YYYY-MM-DDHHmmss").format("dddd, MMMM Do, YYYY")
                            item.eventDate = eventDate
                            item.eventStartTime = eventStartTime
                            item.eventEndTime = eventEndTime
                            item.thisUserCanBook = true// based on age restriction, it will toggle
                            
                      
                            return self.classesGroupBy(item)
                        })
                    },
                    verifyAge: function(item,customerID){
                        // checking if user is able to book a service based on age restriction
                          var isValid = true
                          var user = this.users[customerID]
                          var userAge =  user['age'] 
                          if(user.birthdate && !isNaN(userAge)){
                            if(item.MinAge && userAge < item.MinAge ||item.MaxAge && userAge > item.MaxAge )  isValid = false
                          }
                          //if user birthdate is not present and item min and max is not set, that means this item has no age restrictions so birthdate check not needed
                          else if(!user.birthdate && (item.MinAge || item.MaxAge)) isValid = false
                          return isValid
                      },
                    programErrorMessage: function(item,customerID){
                        var user = this.users[customerID]
                        return  "Sorry, this program requires a person to be " + (item.MinAge ? "atleast " + item.MinAge + (item.MaxAge ? " and " : "") : "") + (item.MaxAge ? "atmost " + item.MaxAge : "") + " years old"   
                    },
                    singleClassErrorMessage: function(item,customerID){
                        return  localStrings.ageRestriction.classRequiredText +" "+ (this.item.MinAge ? localStrings.ageRestriction.preMinAgeText  +" "+ item.MinAge + (item.MaxAge ? +" "+localStrings.ageRestriction.and+" " : "") : "") + (item.MaxAge ? localStrings.ageRestriction.preMaxAgeText  +" "+   item.MaxAge : "") +" "+ localStrings.ageRestriction.yearsOld    + (!app.data.userLoggedIn? '. '+localStrings.ageRestriction.loginToVerify :'') 
                    },
                    moment: function () {
                        return moment();
                    },
                    classComponents: function(){ 
                        var components = app.data.eventPrograms[item.SpaClassId]
                         components = _.sortBy(components,function(x){return x.SortOrder})
                         return components
                    }
                },
                data: function(){
                    return {
                        localStrings: localStrings,
                        localization: app.localization,
                        tempCustomerId: app.data.CustomerId || app.data.DefaultCustomerId
                    }
                }
            });
            Vue.directive('click-outside', {
                bind: function (el, binding, vnode) {
                    this.event = function (event) {
                    if (!(el == event.target || el.contains(event.target))) {
                        vnode.context[binding.expression](event);
                    }
                    };
                    document.body.addEventListener('click', this.event)
                },
                unbind: function (el) {
                    
                },
            });
            require(['vue!optionalClassProgram/components/container','app/views/vue/store/store','helpers'], function (vueApp,store,helpers) {
                helpers.updateNavBar();
                var vm = new Vue({
                    el:'#vue-optional-class-app',
                    store: store,
                   render: function(app){ return app(vueApp,{props:{classComponents:classComponents,program:item}}) }
                });
                app.datal('optionalClassVueAppRef',vm);
            });
        }
    }
);
